var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaricamento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1842",
    "data-name": "Tracciato 1842",
    d: "M756.8,675.8a7.6,7.6,0,1,1-5.374,2.226A7.6,7.6,0,0,1,756.8,675.8Zm-23.784-11.4a9.5,9.5,0,1,1-6.717,2.783A9.5,9.5,0,0,1,733.016,664.4Zm44,1.9a7.6,7.6,0,1,1-5.374,2.226A7.6,7.6,0,0,1,777.012,666.3Zm8.288-15.888a5.7,5.7,0,1,1-4.031,1.669A5.7,5.7,0,0,1,785.3,650.412ZM724.5,637.8a9.5,9.5,0,1,1-6.717,2.783A9.5,9.5,0,0,1,724.5,637.8Zm58.087-3.013A3.8,3.8,0,1,1,779.9,635.9,3.8,3.8,0,0,1,782.587,634.787ZM745.4,615a11.4,11.4,0,1,1-8.061,3.339A11.4,11.4,0,0,1,745.4,615Zm28.5,11.4a1.9,1.9,0,1,1-1.344.556A1.9,1.9,0,0,1,773.9,626.4Z",
    transform: "translate(-715 -615)",
    fill: "#601c7e",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaricamento);
export default __webpack_public_path__ + "static/media/caricamento.34e68ccc513e2036410023b12a84d276.svg";
export { ForwardRef as ReactComponent };